module.exports = __webpack_public_path__ + "assets/game-type-listen.53e43ee4.svg";